var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x-mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x-mark-2",
    "data-name": "x-mark",
    d: "M10,18a8,8,0,1,0-8-8A8,8,0,0,0,10,18ZM8.28,7.22A.75.75,0,0,0,7.22,8.28L8.94,10,7.22,11.72a.75.75,0,1,0,1.06,1.06L10,11.06l1.72,1.72a.75.75,0,1,0,1.06-1.06L11.06,10l1.72-1.72a.75.75,0,0,0-1.06-1.06L10,8.94Z",
    transform: "translate(-2 -2)",
    fill: "#5f6266",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.57dbbe8861b339e4d62c891506b397d5.svg";
export { ForwardRef as ReactComponent };